import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/rootReducer';

// const store = configureStore({
//     reducer: {reducer1: rootReducer}
// })

// export default store;

//////////////////////////////////////////////////////////////////////////

// import { legacy_createStore as createStore} from 'redux';
// import reducers from './reducers/index';

export const store = configureStore(
    { reducer: rootReducer }
)